import 'init.ts';

import Vue from 'vue';
import ClickOutside from '@/directives/ClickOutside';
import Icon from '@/components/ui/Icon.vue';
import Image from '@/components/ui/Image.vue';
import Button from '@/components/ui/Button.vue';
import Typo from '@/components/ui/Typo.vue';
import Row from '@/components/layout/Row.vue';
import Column from '@/components/layout/Column.vue';
import Signature from '@/signature';

import '@/scss/components/carousel';
import '@/scss/components/slider';
import '@/scss/components/slider-gw';

import router from '@/router';
import i18n from '@/translations';
import store from '@/store';

import App from '@/layouts/_app.vue';
import {debounce,} from '@/utils';

let VueCarousel = {};
if (typeof window !== 'undefined') {
	VueCarousel = require('vue-carousel').default;
	//@ts-ignore
	Vue.use(VueCarousel);
}

if (process.env.isPresentableApploudWork) {
	Signature();
}

Vue.component('v-icon', Icon);
Vue.component('v-image', Image);
Vue.component('v-button', Button);
Vue.component('v-typo', Typo);
Vue.component('v-row', Row);
Vue.component('v-column', Column);

ClickOutside();

function nextFactory(context: any, middleware: Function[], index: number) {
	const subsequentMiddleware = middleware[index];
	// If no subsequent Middleware exists,
	// the default `next()` callback is returned.
	if (!subsequentMiddleware) return context.next;

	return (...parameters: any) => {
		// Run the default Vue Router `next()` callback first.
		context.next(...parameters);
		// Then run the subsequent Middleware with a new
		// `nextMiddleware()` callback.
		const nextMiddleware = nextFactory(context, middleware, index + 1);
		subsequentMiddleware({...context, next: nextMiddleware});
	};
}

router.beforeEach((to: any, from: any, next: Function) => {
	if (to.meta.middlewares) {
		const middleware = Array.isArray(to.meta.middlewares)
			? to.meta.middlewares
			: [to.meta.middlewares];

		const context = {
			from,
			to,
			router,
			store,
			i18n,
			next
		};
		const nextMiddleware = nextFactory(context, middleware, 1);

		return middleware[0]({...context, next: nextMiddleware});
	}

	return next();
});

const app = new Vue({
	name: 'AppWrapper',
	i18n,
	router,
	store,

	render: (h) => h(App),

	async created(): Promise<void> {
		this.$root.$on('canGenerate', () => {
			window.generateStatus = 'ready';
		});
	},

	mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}
		this.resizeEndHandler();
		window.addEventListener('resize', debounce(this.resizeEndHandler, 200));
		//@ts-ignore
		//new SmoothScroll(document, 24, 12);
	},

	methods: {
		async resizeEndHandler() {
			const width: number = window.innerWidth;
			const isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || width <= 768);
			(isMobile) ? document.documentElement.classList.remove('hover') : document.documentElement.classList.add('hover');

			const globalState = {
				isMobile,
				width
			};

			// @ts-ignore-next-line
			if (globalState.width === this.$store.state.global.width) {
				return;
			}

			await store.dispatch('updateGlobalState', globalState);
		},
	}


});

if (process.env.NODE_ENV === 'development') {
	console.log(app);

	if (typeof window !== 'undefined') {
		// @ts-ignore
		window.app = app;
	}

}

export default app;
